import { JobsZeroResultsProps } from '@/components/jobs-zero-results';

import { JobListProps } from '@/features/job-category-page/components/job-category-jobs-list';
import jobCategoryJobBlocksFromJobListProps from '@/features/job-category-page/mappers/job-category-job-blocks.mapper';
import { jobSearchQueryFromJobCategoryPage } from '@/features/job-category-page/mappers/job-category-job-search.mapper';
import { isNurse } from '@/utils/discipline-utils';
import { routes } from '@/utils/route-utils';

export const jobCategoryPageJobsZeroResultsFromJobListProps = (
  props: JobListProps
): JobsZeroResultsProps => {
  return {
    title: `Oops! We're sorry no jobs match that criteria.`,
    subtitle: prepareSubtitle(props),
    link: prepareLink(props),
    relatedJobs: props.relatedJobs || [],
    jobBlocksProps: jobCategoryJobBlocksFromJobListProps(props),
  };
};

const prepareSubtitle = ({
  page: { discipline, specialty, disciplineType },
  relatedJobsLevel,
}: JobListProps): string => {
  if (relatedJobsLevel === 'specialty') {
    return `But we do have lots of ${specialty?.title} jobs. Check these out...`;
  }

  if (relatedJobsLevel === 'discipline') {
    return `But we do have lots of ${discipline?.title} jobs. Check these out...`;
  }

  if (isNurse(disciplineType)) {
    return `But we do have lots of travel nurse jobs. Check these out...`;
  }

  return `But we do have lots of allied health jobs. Check these out...`;
};

const prepareLink = ({
  page: { discipline, specialty, disciplineType },
  relatedJobsLevel,
}: JobListProps): JobsZeroResultsProps['link'] => {
  if (relatedJobsLevel === 'specialty') {
    return {
      text: `Search more ${specialty?.title} jobs`,
      href: routes.jobSearch(
        jobSearchQueryFromJobCategoryPage({
          discipline,
          specialty,
          disciplineType,
        })
      ),
    };
  }

  if (relatedJobsLevel === 'discipline') {
    return {
      text: `Search more ${discipline?.title} jobs`,
      href: routes.jobSearch(
        jobSearchQueryFromJobCategoryPage({
          discipline,
          disciplineType,
        })
      ),
    };
  }

  if (isNurse(disciplineType)) {
    return {
      text: `Search more travel nurse jobs`,
      href: routes.jobSearch(
        jobSearchQueryFromJobCategoryPage({
          disciplineType,
        })
      ),
    };
  }

  return {
    text: `Search more allied health jobs`,
    href: routes.jobSearch({}),
  };
};
